import { render, staticRenderFns } from "./AlertMsg.vue?vue&type=template&id=3a169528&scoped=true&"
import script from "./AlertMsg.vue?vue&type=script&lang=js&"
export * from "./AlertMsg.vue?vue&type=script&lang=js&"
import style0 from "./AlertMsg.vue?vue&type=style&index=0&id=3a169528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a169528",
  null
  
)

export default component.exports